import type { WidgetDialogVariant, WidgetLauncherVariant } from '@vd/types';
import type { OptionBox } from './OptionBoxes';

/**
 * Canonical label + description for each launcher and dialog choice, so the
 * onboarding quick-setup and the Widget Studio present them identically.
 */
export const LAUNCHER_VARIANT_OPTIONS: ReadonlyArray<OptionBox<WidgetLauncherVariant>> = [
  { value: 'button', label: 'Floating button', hint: 'A round button pinned to a corner.' },
  { value: 'tab', label: 'Edge tab', hint: 'A tab flush against a screen edge.' },
  { value: 'inline', label: 'Inline', hint: 'Renders where you drop a <span data-toado-launcher> in your markup, e.g. a header.' },
  { value: 'hidden', label: 'Hidden', hint: 'No visible launcher. Use the keyboard shortcut, or open it from your own UI with Toado.open().' },
];

export const DIALOG_VARIANT_OPTIONS: ReadonlyArray<OptionBox<WidgetDialogVariant>> = [
  { value: 'modal', label: 'Modal', hint: 'A centered dialog over a dimmed backdrop.' },
  { value: 'panel', label: 'Panel', hint: 'Pinned beside the launcher; the page stays usable.' },
];
